import $ from 'jquery'
import CustomCheckbox from '../../../../../../js/components/customCheckbox/CustomCheckbox'
import LeaveTypesSelectorButton from '../../../../../../js/controls/LeaveTypesSelectorButton'
import messageResource from '../../../../../../js/messageResource'
import TemplateView from '../../../../../../js/TemplateView'
import {DEFAULT_LEAVE_TYPE_SELECTION} from '../constants'

export default class ICalFeedLeaveTypesSelector extends TemplateView {
    constructor({
        selectorId,
        onLeaveTypeSelectionChanged,
        onCheckboxClick,
    }) {
        super()

        this.state = {
            leaveTypes: [],
            leaveTypeSelection: DEFAULT_LEAVE_TYPE_SELECTION,
            includeNotApproved: false,
        }

        this.params = {
            selectorId,
        }

        this.callbacks = {
            onLeaveTypeSelectionChanged,
            onCheckboxClick,
        }
        this.onAnyStatePropertyDeeplyChanged(['leaveTypes', 'leaveTypeSelection'], () => this._refresh())

        this.onStatePropertyChanged('includeNotApproved', includeNotApproved =>
            this.includeNotApprovedCheckbox.setState({checked: includeNotApproved}))
    }

    templateHtml() {
        return `<div class='field'>
                    <div class='fieldTitle'>
                        <%=userSelectorTitle%>
                    </div>
                    <div id='<%=selectorId%>' class='fieldInput leavesSelectorWrapper x-btn-no-border'/>
                    <div class='fieldInput includeWaitingRequests'>
                        <div class='checkboxWrapper'/>
                    </div>
                </div>`
    }

    templateModel() {
        return {
            selectorId: this.params.selectorId,
        }
    }

    messageKeys() {
        return {
            userSelectorTitle: 'icalendar.page.lightbox.leavetypes.description',
        }
    }

    afterRender() {
        this.$leavesButton = this.find('#' + this.params.selectorId)
        this._refresh()

        this.includeNotApprovedCheckbox = new CustomCheckbox({
            label: messageResource.getMessage('icalendar.page.lightbox.leavetypes.include_waiting_for_approval'),
            checked: this.state.includeNotApproved,
            onChange: () => this.callbacks.onCheckboxClick(!this.state.includeNotApproved),
            containerAdditionalClass: 'includeCheckbox',
            checkboxTitleAdditionalClass: 'checkboxTitle',
        }).init(this.find('.checkboxWrapper'))
    }

    _refresh() {
        this.$leavesButton.empty()
        if (!this.state.leaveTypeSelection) {
            return
        }

        this.leavesSelector = new LeaveTypesSelectorButton().init({
            renderTo: this.params.selectorId,
            leavesSelection: {
                qualifier: this.state.leaveTypeSelection.qualifier === window.LeaveTypeSelectionQualifier.ALL,
                showArchived: this.state.leaveTypeSelection.showArchived,
                leaveTypes: this.state.leaveTypeSelection.leaveTypes,
            },
            leavesData: $.extend(true, [], this.state.leaveTypes),
            ptoFeatureEnabled: window.SystemSettings.apPtoBalanceCalculationEnabled,
            sickBalanceFeatureEnabled: window.SystemSettings.apSickBalanceCalculationEnabled,
            changeCallback: () => {
                const currentSelection = this.leavesSelector.getLeaveTypeSelection()
                this.callbacks.onLeaveTypeSelectionChanged({
                    qualifier: currentSelection.qualifier ? window.LeaveTypeSelectionQualifier.ALL : window.LeaveTypeSelectionQualifier.SELECTED,
                    showArchived: currentSelection.showArchived,
                    leaveTypes: currentSelection.leaveTypes,
                })
            },
            withApplyButton: true,
            extraClass: 'iCalLeaveTypeSelector',
            isMarkAllSelectedIfEmpty: true,
            showInactiveCheckbox: true,
            isMarkAllSelectedIfEmptyOnInit: false,
            labelNoItemsSelectedKey: 'icalendar.page.table.leave_types.none',
        })
    }
}



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/ICalFeedLeaveTypesSelector.js